<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-button @click="$router.push('/collection')">back</md-button>
      <md-dialog class="media_dialog" :md-active.sync="showDialog">
        <md-dialog-title>Add to Collection</md-dialog-title>

        <div class="dialog-table">
          <md-table :value="tableData" md-card @md-selected="onSelect">
            <md-table-toolbar>
              <h1 class="md-title">Select from Galleries</h1>
            </md-table-toolbar>

            <md-table-toolbar
              slot="md-table-alternate-header"
              slot-scope="{ count }"
            >
              <div class="md-toolbar-section-start">
                {{ getAlternateLabel(count) }}
              </div>

              <div class="md-toolbar-section-end">
                <md-button @click="addMultipleMedia" class="md-button"
                  >Add</md-button
                >
              </div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select
              :md-disabled="checkIfItemExist(item.id)"
            >
              <md-table-cell md-label="Title">{{
                item.title.toUpperCase()
              }}</md-table-cell>
              <md-table-cell md-label="# of Photos">{{
                item.media_collection.length
              }}</md-table-cell>
              <md-table-cell md-label="Uploaded By" md-sort-by="uploadedBy">{{
                item.uploadedBy
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <md-dialog-actions>
          <md-button @click="save" class="md-button">Save</md-button>
          <md-button @click="showDialog = false" class="md-button"
            >Cancel</md-button
          >
        </md-dialog-actions>
      </md-dialog>
      <md-card>
        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input
              @keydown="showSaveBtn = true"
              v-model="collection.title"
              type="text"
            ></md-input>
            <md-button v-if="showSaveBtn" @click="save" class="md-button"
              >Save</md-button
            >
          </md-field>
        </md-card-content>
      </md-card>
      <md-card style="padding: 10px 20px 10px 20px;">
        <md-dialog-title>Gallery Arrangement</md-dialog-title>
        <md-card-content>
          <transition-group style="flex-wrap: wrap; display: flex;">
            <div
              style="cursor:pointer"
              class="album"
              @click="openAlbum(element.id)"
              v-for="element in galleries"
              :key="element.id"
            >
              <p
                style="background: aliceblue; text-indent: 10px; font-weight: 500;"
              >
                {{ element.title }}
              </p>
              <div class="sub-img-disp">
                <div
                  class="sub-img"
                  v-for="(image, index) in element.media_collection.slice(0, 4)"
                  :style="{ backgroundImage: `url(${image.url})` }"
                  :key="index"
                ></div>
              </div>
            </div>
          </transition-group>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button
            class="md-primary md-round md-small"
            @click="showDialog = true"
            >Add Gallery</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import Upload from "@/components/Inputs/Upload.vue";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    Upload
  },
  data() {
    return {
      clients: null,
      showDialog: false,
      showSaveBtn: false,
      tableData: [],
      galleries: [],
      collection: {
        title: null,
        private: false,
        gallery_collection: [],
        uploadedBy: null
      },
      selected: []
    };
  },
  watch: {},
  firestore() {
    return {
      collection: db
        .collection("collection")
        .doc(this.$route.params.collection_id),
      tableData: db.collection("gallery")
    };
  },
  watch: {
    tableData() {
      let arrayOfIds = this.collection.gallery_collection;
      this.galleries = this.tableData.filter(g => {
        if (arrayOfIds.includes(g.id)) {
          return g;
        }
      });
    }
  },

  methods: {
    openAlbum(id) {
      this.$router.push("/gallery/" + id);
    },
    checkIfItemExist(id) {
      return this.collection.gallery_collection.find(m => m == id)
        ? true
        : false;
    },
    addMedia(media) {
      this.media = media;
    },
    addMultipleMedia() {
      let selectedId = this.selected.map(item => item.id);
      this.collection.gallery_collection.push(...selectedId);
      this.selected = [];
    },

    updatePrivacy(item) {
      db.collection("collection")
        .doc(item.id)
        .update({ private: item.private });
    },

    showImage(item) {
      let id = item.id;
    },
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }

      return `${count} user${plural} selected`;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("collection")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
            });
        }
      });
    },

    save() {
      let vm = this;

      return db
        .collection("collection")
        .doc(vm.collection.id)
        .set(vm.collection, { merge: true })
        .then(() => {
          return Swal.fire("Success", "Page Updated", "success");
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.media_dialog {
  width: 800px;
  overflow-y: auto;
  height: 600px;
}

.md-dialog {
  max-width: 768px;
}

.tabs {
  margin-top: 5%;
}
</style>
